const FORGE_HANDOFF_SOURCE = "nbw-forge";
const INCIDENT_REF_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:/-]{0,159}$/u;

export function forgeIncidentHandoffFromSearch(search: string): string | null {
  const query = new URLSearchParams(search);
  const keys = [...query.keys()];
  if (keys.length !== 2 || keys.filter((key) => key === "source").length !== 1 || keys.filter((key) => key === "incident").length !== 1) {
    return null;
  }
  const incidentRef = query.get("incident");
  return query.get("source") === FORGE_HANDOFF_SOURCE
    && incidentRef !== null
    && INCIDENT_REF_PATTERN.test(incidentRef)
    ? incidentRef
    : null;
}
